import type { CurrentAccount, Plan } from '../../../../types';

const PRO_PLAN_NAME = 'Pro (2,000 Tasks)';
const PRO_PLAN_INTERVAL = 'year';

type BuildUpgradeUrlOpts = {
  currentPlanName?: string;
  upgradePlanName?: string;
  interval: 'month' | 'year';
};
export const buildUpgradeUrl = (opts: BuildUpgradeUrlOpts) => {
  const currentPlanName = (opts.currentPlanName || '').toLowerCase();
  const upgradePlanName = (opts.upgradePlanName || '').toLowerCase();
  const url =
    currentPlanName && upgradePlanName
      ? `/app/checkout/upgrade/${currentPlanName}/${upgradePlanName}?interval=${
          opts.interval || 'month'
        }`
      : '/app/pricing';
  return encodeURI(url);
};

export const getProfessionalPlanData = (
  possiblePlans: Array<{
    planType: string;
    plans: Array<Plan>;
  }>,
  currentAccount: CurrentAccount
) => {
  const professionalPlan = possiblePlans
    .find((plan) => plan.planType === 'Professional')
    ?.plans.find(
      (plan) =>
        plan.name === PRO_PLAN_NAME && plan.interval === PRO_PLAN_INTERVAL
    ); // annual pro plan

  const professionalUpgradeUrl = buildUpgradeUrl({
    currentPlanName: currentAccount.plan.name,
    upgradePlanName: professionalPlan?.name || PRO_PLAN_NAME,
    interval: currentAccount.plan.interval,
  });

  // Divide by 12 since `nextPlan` is always annual.
  const professionalPlanAmount = (professionalPlan?.amount || 0) / 12;

  return { professionalUpgradeUrl, professionalPlanAmount };
};
